import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { AlertCircle } from 'lucide-react';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export function SessionTimeout() {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(SESSION_TIMEOUT);

  useEffect(() => {
    let warningTimer: NodeJS.Timeout;
    let logoutTimer: NodeJS.Timeout;

    const resetTimers = () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);
      setShowWarning(false);
      setTimeLeft(SESSION_TIMEOUT);

      // Set new timers
      warningTimer = setTimeout(() => {
        setShowWarning(true);
      }, SESSION_TIMEOUT - (5 * 60 * 1000)); // Show warning 5 minutes before timeout

      logoutTimer = setTimeout(() => {
        supabase.auth.signOut();
      }, SESSION_TIMEOUT);
    };

    // Reset timers on user activity
    const handleActivity = () => resetTimers();

    // Initial setup
    resetTimers();

    // Add event listeners
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    return () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, []);

  if (!showWarning) return null;

  return (
    <div className="fixed bottom-4 right-4 max-w-sm bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-4 shadow-lg">
      <div className="flex items-start">
        <AlertCircle className="w-5 h-5 text-yellow-500 mr-3 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-medium text-white">Session Timeout Warning</h3>
          <p className="text-sm text-gray-300 mt-1">
            Your session will expire in {Math.ceil(timeLeft / 60000)} minutes.
            Please save your work and refresh the page to continue.
          </p>
        </div>
      </div>
    </div>
  );
}